import React from 'react';
import QuantitySelectorPrivateLabel from './QuantitySelectorPrivateLabel';

const QuantityPrivateLabel = ({
                                product,
                                variant = 'default',
                                label,
                                isLoading,
                                onQuantityChange
                              }) => {
  return (
    <QuantitySelectorPrivateLabel
      quantity={product.quantity}
      variant={variant}
      label={label}
      isLoading={isLoading}
      onQuantityChange={onQuantityChange}
    />
  );
};


export default React.memo(QuantityPrivateLabel);
